import {
  CREATE_STAFF,
  CREATE_STAFF_SUCCESS,
  CREATE_STAFF_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const createStaffReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_STAFF:
      return { ...state, loading: true };
    case CREATE_STAFF_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case CREATE_STAFF_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default createStaffReducer;
